import { createIcon } from './create-icon';

export const CheckIcon = createIcon('CheckIcon', <path d="M20 6L9 17l-5-5" />);
